var isObject = require('../internals/is-object');
module.exports = function (it) {
    if (!isObject(it) && it !== null) {
        throw TypeError('Can\'t set ' + String(it) + ' as a prototype');
    }
    return it;
};